<template>
  <div class="image-generator">
    <button
      @click="generateImage"
      :disabled="isLoading || !prompt"
      class="btn btn-primary"
      :class="{ 'btn-loading': isLoading }"
    >
      <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
      {{ buttonText || 'יצירת תמונה' }}
    </button>

    <!-- Error message -->
    <div v-if="error" class="alert alert-danger mt-2">
      {{ error }}
    </div>

    <!-- Generated image display -->
    <div v-if="generatedImageUrl" class="mt-3">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h6 class="mb-0">תמונה שנוצרה</h6>
          <button @click="clearImage" class="btn btn-sm btn-outline-secondary">
            <i class="fas fa-times"></i>
            <span class="ms-1">סגור</span>
          </button>
        </div>
        <div class="card-body text-center">
          <!-- Image hidden from display but URL is still available for PDF generation -->
          <div class="text-muted">
            <i class="fas fa-check-circle text-success"></i>
            התמונה נוצרה בהצלחה
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageGenerator',
  props: {
    prompt: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: 'יצירת תמונה'
    },
    size: {
      type: String,
      default: '1024x1024'
    }
  },
  data () {
    return {
      isLoading: false,
      generatedImageUrl: null,
      error: null
    }
  },
  methods: {
    async generateImage () {
      if (!this.prompt) {
        this.error = 'נדרש prompt ליצירת התמונה'
        return
      }

      this.isLoading = true
      this.error = null
      this.generatedImageUrl = null

      try {
        const response = await this.$caller.request('POST', 'generate_image', 'admin_headers', {
          prompt: this.prompt,
          size: this.size
        })

        if (response.status === 'success' && response.image_url) {
          this.generatedImageUrl = response.image_url
          this.$emit('image-generated', response.image_url)
        } else {
          this.error = response.error || 'שגיאה ביצירת התמונה'
        }
      } catch (error) {
        console.error('Error generating image:', error)
        this.error = 'שגיאה בחיבור לשירות יצירת התמונות'
      } finally {
        this.isLoading = false
      }
    },
    clearImage () {
      this.generatedImageUrl = null
      this.error = null
      this.$emit('image-cleared')
    }
  },
  watch: {
    prompt () {
      // Clear previous results when prompt changes
      this.clearImage()
    }
  }
}
</script>

<style scoped>
.image-generator {
  margin: 10px 0;
}

.btn-loading {
  opacity: 0.7;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.card {
  border: 1px solid #dee2e6;
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.alert {
  font-size: 0.9rem;
}

img {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
</style>
